module.exports = __webpack_public_path__ + "04_glasses_black.d5fbf308.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/04_glasses_black.png
// module id = 1tf/
// module chunks = 0